export default __webpack_public_path__ + "static/media/1239.64c89023.png";